import { JivoBot, JivoBotsService } from '../api';

interface JivoChatProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: JivoBot[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: JivoBot }>;
  getOne: (resource: string, params: any) => Promise<{ data: JivoBot }>;
  update: (resource: string, params: any) => Promise<{ data: JivoBot }>;
}

export const jivoChatsProvider: JivoChatProviderResource = {
  getList: async (resource, params) => {
    console.log(params);
    const { items } = await JivoBotsService.listJivoBots();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    var data: JivoBot[] = [];
    console.log(params.filter.model_id);
    if (params.filter.model_id) {
      console.log(items);
      for (const item of items) {
        if (item.model_id === params.filter.model_id) {
          data.push(item);
        }
      }
    } else {
      data = items;
    }
    return {
      data: data,
      total: data.length,
    };
  },
  create: async (resource, params) => {
    console.log(params);
    const chat = await JivoBotsService.jivoBotAdd(params.data);
    return { data: chat };
  },
  getOne: async (resource, params) => {
    const chat = await JivoBotsService.getJivoBot(params.id);
    return { data: chat };
  },
  update: async (resource, params) => {
    console.log(params);
    const {
      data: { name, provider_id, token, start_message, model_id },
    } = params;
    const chat = await JivoBotsService.updateJivoBot(params.id, {
      name,
      provider_id,
      token,
      start_message,
      model_id,
    });
    return { data: chat };
  },
};
